import React from "react";
import PolicyLayout from "../components/PolicyLayout";

const privacyPolicyContent = [
  {
    id: "information-we-collect",
    title: "Information We Collect",
    content:
      "We may collect your name, phone number, email address, billing and shipping address, order details, payment reference, and communication history when you browse, register, place an order, or contact Tanuraaga.",
  },
  {
    id: "how-we-use-information",
    title: "How We Use Information",
    content:
      "Your information is used to process saree orders, confirm payments, arrange delivery, manage returns or refunds, provide customer support, improve our website, and share important order updates.",
  },
  {
    id: "payment-security",
    title: "Payment Security",
    content:
      "Tanuraaga does not intentionally store complete card or sensitive banking details on the website. Payments may be handled by secure third-party payment providers according to their own security practices.",
  },
  {
    id: "sharing-information",
    title: "Sharing Information",
    content:
      "We may share necessary information with courier partners, payment processors, technology service providers, or support teams only for order fulfilment, service operation, fraud prevention, or legal compliance.",
  },
  {
    id: "marketing-communication",
    title: "Marketing Communication",
    content:
      "With your consent or where permitted, we may send updates about saree collections, offers, and store announcements. You may request to stop receiving promotional communication at any time.",
  },
  {
    id: "cookies-and-analytics",
    title: "Cookies And Analytics",
    content:
      "Our website may use cookies or similar technologies to remember preferences, improve browsing, understand product interest, and maintain website performance.",
  },
  {
    id: "data-protection",
    title: "Data Protection",
    content:
      "We take reasonable steps to protect customer information from unauthorized access, misuse, or disclosure. However, no internet-based system can be guaranteed to be completely secure.",
  },
  {
    id: "customer-rights",
    title: "Customer Rights",
    content:
      "You may contact us to request correction, update, or deletion of your personal information, subject to order, legal, accounting, or legitimate business record requirements.",
  },
  {
    id: "contact-us",
    title: "Contact Us",
    content:
      "For privacy-related questions, contact Tanuraaga at tanuraaga.weaves@gmail.com or +91 7411134054. We will review your request and respond as soon as reasonably possible.",
  },
];

const PrivacyPolicyPage = () => (
  <PolicyLayout
    activeLabel="Privacy Policy"
    className="privacy-policy-page"
    title="Privacy Policy"
    intro={{
      title: "Your Privacy Matters",
      content:
        "Tanuraaga respects customer privacy. This policy explains how we collect, use, protect, and share information when you shop for sarees or interact with our website.",
    }}
    sections={privacyPolicyContent}
  />
);

export default PrivacyPolicyPage;
